import { Component, inject } from '@angular/core';
import { RemsoftSpeciesGroupService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RemsoftSpeciesGroupCreateDto,
  RemsoftSpeciesGroupDto,
  RemsoftSpeciesGroupExcelDownloadDto,
  RemsoftSpeciesGroupUpdateDto,
} from '../proxy/general/dtos/remsoft-species-group';
import { REMSOFTSPECIESGROUP_CONFIG, REMSOFTSPECIESGROUP_FIELDS } from './remsoft-species-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-remsoft-species-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RemsoftSpeciesGroupService, ConfirmationService],
  templateUrl: './remsoft-species-group.html',
  styleUrl: './remsoft-species-group.scss',
})
export class RemsoftSpeciesGroup extends BaseCrudComponent<
  RemsoftSpeciesGroupDto,
  RemsoftSpeciesGroupCreateDto,
  RemsoftSpeciesGroupUpdateDto,
  RemsoftSpeciesGroupExcelDownloadDto
> {
  service = inject(RemsoftSpeciesGroupService);
  config = REMSOFTSPECIESGROUP_CONFIG;
  fields = REMSOFTSPECIESGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: RemsoftSpeciesGroupDto): RemsoftSpeciesGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RemsoftSpeciesGroup';
  }
}
